/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Account_Credentials_Quick_Action_SublineInputs */

const de_account_credentials_quick_action_subline = /** @type {(inputs: Account_Credentials_Quick_Action_SublineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-Mail-Adresse und Passwort ändern`)
};

/** @type {(inputs: Account_Credentials_Quick_Action_SublineInputs) => LocalizedString} */
const en_account_credentials_quick_action_subline = de_account_credentials_quick_action_subline;

/**

* @param {Account_Credentials_Quick_Action_SublineInputs} inputs
* @param {{ locale?: "de" | "en" }} options
* @returns {LocalizedString}
*/
export const account_credentials_quick_action_subline = /** @type {((inputs?: Account_Credentials_Quick_Action_SublineInputs, options?: { locale?: "de" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Account_Credentials_Quick_Action_SublineInputs, { locale?: "de" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_account_credentials_quick_action_subline(inputs)
	return en_account_credentials_quick_action_subline(inputs)
});